import React from "react";
import ReactDOM from "react-dom";
import "core/scss/index.scss";
import "antd/dist/antd.css";
import "bootstrap/dist/css/bootstrap.min.css";
import App from "core/components/App";
import { BrowserRouter } from "react-router-dom";

ReactDOM.render(
  <BrowserRouter basename={process.env.PUBLIC_URL}>
    <App />
  </BrowserRouter>,
  document.getElementById("root")
);
